import { FormHelperText, Grid } from "@material-ui/core";
import React, { Component, Fragment } from "react";
import { Prompt } from "react-router";
import { Link } from "react-router-dom";
import { userFarmDetail } from "../../../config/farmDetails";
import { userDetail } from "../../../config/userDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import Button from "../../FormElement/Button";
import Dropdown from "../../FormElement/Dropdown";
import { validForm } from "../../FormElement/FormValidator";
import InputFiled from "../../FormElement/InputFiled";

const signInSectionStyle = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
};

class UsersForm extends Component {
  constructor(props) {
    super(props);
    const { userInfo, SubFarmId, MainFarmId } = props;
    this.state = {
      userInfo: {
        farmId: SubFarmId || userFarmDetail().id || MainFarmId,
        firstName: userInfo ? userInfo.firstName : null,
        lastName: userInfo ? userInfo.lastName : null,
        username: userInfo ? userInfo.username : null,
        password: userInfo ? userInfo.password : null,
        confirmPassword: userInfo ? userInfo.confirmPassword : null,
        role: userInfo ? userInfo.roleName : "FARM_EMPLOYEE"
      },
      formErrors: {
        firstName: "",
        lastName: "",
        username: "",
        password: "",
        role: ""
      },
      isInvalid: true,
      edited: false
    };
  }

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    const { name, value } = event.target;
    if (name === "firstName" || name === "lastName") {
      if (value.match(/^(\w|\ ){0,51}$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          userInfo: {
            ...prevState.userInfo,
            [name]: value
          }
        };
      },
      () => {
        const { userInfo } = this.state;
        const { editMode } = this.props;
        const requiredFields = { ...userInfo };
        if (editMode) {
          delete requiredFields.password;
          delete requiredFields.confirmPassword;
        }
        this.validateAll(requiredFields);
      }
    );
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { userInfo } = this.state;
        const { editMode } = this.props;
        const requiredFields = { ...userInfo };
        if (editMode) {
          delete requiredFields.password;
          delete requiredFields.confirmPassword;
        }
        this.validateAll(requiredFields);
      }
    );
  };

  validateAll = formFields => {
    this.setState({
      isInvalid: validForm(this.state.formErrors, formFields)
    });
  };

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  validateResetForm = () => {
    const { password, confirmPassword } = this.state.userInfo;
    if (confirmPassword !== "" || confirmPassword !== null)
      return password === confirmPassword;
    else return true;
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ isInvalid: true, edited: false });
    const { userInfo } = this.state;
    this.props.handleSubmit(userInfo);
  };

  render() {
    const {
      farmId,
      firstName,
      lastName,
      username,
      password,
      role,
      confirmPassword
    } = this.state.userInfo;
    const { isInvalid, edited } = this.state;
    const { editMode = false, formLabel, buttonLabel, MainFarmId } = this.props;
    return (
      <div className="">
        <Prompt when={edited} message="Changes you made may not be saved." />
        <div className="textRequired">* Required Cells</div>
        <div className="innermainform">
          <p className="loginHeader">{formLabel}</p>
          <Grid container>
            <Grid item xs={12}>
              <InputFiled
                value={lastName}
                label="Last Name"
                type="text"
                name="lastName"
                required
                validations={["minSize", "required", "maxSize"]}
                handleChange={this.handleChange}
                //handleError={this.handleError}
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                value={firstName}
                label="First Name"
                type="text"
                name="firstName"
                required
                validations={["minSize", "required", "maxSize"]}
                handleChange={this.handleChange}
                //handleError={this.handleError}
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                value={username}
                disabled={editMode}
                label="Email/Username"
                type="email"
                name="username"
                required
                validations={["email", "required"]}
                handleChange={this.handleChange}
                //handleError={this.handleError}
              />
            </Grid>
            {!editMode && (
              <Fragment>
                <Grid item xs={12}>
                  <InputFiled
                    value={password}
                    label="Password"
                    type="password"
                    name="password"
                    required
                    validations={["password", "required"]}
                    handleChange={this.handleChange}
                    //handleError={this.handleError}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputFiled
                    value={confirmPassword}
                    label="Confirm Password"
                    type="password"
                    name="confirmPassword"
                    required
                    validations={["required"]}
                    handleChange={this.handleChange}
                    handleError={this.handleError}
                  />
                  {!this.validateResetForm() && (
                    <FormHelperText>
                      <span className="error" role="alert">
                        Your password confirmation did not match your password
                      </span>
                    </FormHelperText>
                  )}
                </Grid>
              </Fragment>
            )}

            <Grid item xs={12}>
              <Dropdown
                value={role}
                label="Role Type"
                required
                type="text"
                name="role"
                disabled={
                  farmId !== userFarmDetail().id && farmId !== MainFarmId
                }
                options={
                  DropdownOptions.roleTypes[
                    isSuperAdmin() ? "ACCOUNT_OWNER" : userDetail().roleName
                  ]
                }
                validations={["required"]}
                handleChange={this.handleChange}
                //handleError={this.handleError}
              />
            </Grid>
          </Grid>
          <div className="signInSection" style={signInSectionStyle}>
            <Link to="/settings/users" style={{ color: "blue" }}>
              Cancel
            </Link>
            <Button
              disabled={isInvalid || !this.validateResetForm()}
              name={buttonLabel}
              styleClass="signIn"
              onclick={this.handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default UsersForm;



// WEBPACK FOOTER //
// ./src/components/private/Users/UsersForm.js